/* Banner de cookies Charmant.
   - Guarda la elección en localStorage (para no repreguntar) Y la comunica
     a la Customer Privacy API de Shopify, que es quien de verdad activa o
     bloquea los píxeles y la analítica. Antes "Rechazar" solo apuntaba la
     preferencia sin bloquear nada.
   - Accesibilidad: el modal es role=dialog con foco gestionado, ciclo de
     Tab, cierre con Escape y devolución del foco al botón que lo abrió. */

(function () {
  'use strict';

  var STORAGE_KEY = 'charmant_cookie_consent';

  function applyConsentToShopify(analytics, marketing) {
    var send = function () {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: analytics,
            marketing: marketing,
            preferences: true,
            sale_of_data: marketing,
          },
          function () {}
        );
      } catch (e) {}
    };
    if (window.Shopify && window.Shopify.customerPrivacy) {
      send();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (!error) send();
        }
      );
    }
  }

  function init() {
    var banner = document.getElementById('cookieBanner');
    var modal = document.getElementById('cookieModal');
    if (!banner || !modal) return;

    var modalBox = modal.querySelector('.cookie-modal__box');
    var configureBtn = document.getElementById('cookieConfigure');
    var previousFocus = null;

    var stored = null;
    try { stored = localStorage.getItem(STORAGE_KEY); } catch (e) {}

    /* La clase en <html> desactiva el rebote de iOS mientras el aviso está
       en pantalla. Sin ella, al arrastrar más allá del final de la página
       Safari despega la página entera —lo fijo incluido— y la tarjeta se
       mueve de verdad. Se quita en cuanto ella decide, para devolverle a la
       tienda su forma normal de desplazarse. */
    var RAIZ = document.documentElement;
    var CLASE_REBOTE = 'charmant-cookies-pendientes';

    if (!stored) {
      setTimeout(function () {
        banner.classList.add('active');
        RAIZ.classList.add(CLASE_REBOTE);
      }, 1500);
    } else {
      /* Reaplicar la elección guardada en cada visita: la Privacy API
         no persiste entre sesiones por sí sola */
      try {
        var saved = JSON.parse(stored);
        applyConsentToShopify(!!saved.analytics, !!saved.marketing);
      } catch (e) {}
    }

    function saveConsent(analytics, marketing) {
      try {
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({ analytics: analytics, marketing: marketing, date: Date.now() })
        );
      } catch (e) {}
      applyConsentToShopify(analytics, marketing);
      banner.classList.remove('active');
      RAIZ.classList.remove(CLASE_REBOTE);
      closeModal();
      /* Avisar de que ya hay decisión tomada. Lo escucha el popup de
         bienvenida (assets/welcome-popup.js) para arrancar su cuenta atrás
         justo ahora y no antes: si contara desde que carga la página, se
         plantaría encima de esta tarjeta, que no se quita sola. Dos ventanas
         a la vez y no se entiende ninguna. */
      try {
        document.dispatchEvent(new CustomEvent('charmant:cookie-consent'));
      } catch (e) {}
    }

    /* --- Modal accesible --- */
    function focusables() {
      return Array.prototype.filter.call(
        modalBox.querySelectorAll('button, input, a[href]'),
        function (el) { return el.offsetParent !== null; }
      );
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { closeModal(true); return; }
      if (e.key === 'Tab') {
        var items = focusables();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    }

    function openModal() {
      previousFocus = document.activeElement;
      /* Reflejar la elección que ya está guardada. Quien reabre el panel para
         cambiar de opinión tiene que ver lo que está activo AHORA, no las
         casillas por defecto: si no, parece que nada está aceptado. */
      try {
        var current = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        var analyticsBox = document.getElementById('cookieAnalytics');
        var marketingBox = document.getElementById('cookieMarketing');
        if (analyticsBox) analyticsBox.checked = !!current.analytics;
        if (marketingBox) marketingBox.checked = !!current.marketing;
      } catch (e) {}
      modal.classList.add('active');
      var close = modal.querySelector('.cookie-modal__close');
      if (close) close.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeModal(returnFocus) {
      if (!modal.classList.contains('active')) return;
      modal.classList.remove('active');
      document.removeEventListener('keydown', onKeydown);
      if (returnFocus && previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
    }

    document.getElementById('cookieAccept').addEventListener('click', function () {
      saveConsent(true, true);
    });
    document.getElementById('cookieReject').addEventListener('click', function () {
      saveConsent(false, false);
    });
    configureBtn.addEventListener('click', openModal);
    document.getElementById('cookieModalClose').addEventListener('click', function () {
      closeModal(true);
    });
    document.getElementById('cookieAcceptAll').addEventListener('click', function () {
      document.getElementById('cookieAnalytics').checked = true;
      document.getElementById('cookieMarketing').checked = true;
      saveConsent(true, true);
    });
    document.getElementById('cookieSavePrefs').addEventListener('click', function () {
      saveConsent(
        document.getElementById('cookieAnalytics').checked,
        document.getElementById('cookieMarketing').checked
      );
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal(true);
    });

    /* Disparador externo: cualquier elemento con [data-charmant-cookie-settings]
       reabre el panel de preferencias. Lo usa el enlace «Configurar cookies» del
       pie de página, que es la vía para retirar el consentimiento y sin la cual
       no se puede cumplir el art. 7.3 del RGPD. Delegado en document para que
       funcione con enlaces que se inserten después de cargar la página. */
    document.addEventListener('click', function (e) {
      var trigger =
        e.target && e.target.closest
          ? e.target.closest('[data-charmant-cookie-settings]')
          : null;
      if (!trigger) return;
      e.preventDefault();
      openModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
